import { ApiResponseData, api } from '~shared/api';

import { routes } from './routes';
import { ApiCoordinatesData, ApiUpdateResponseData } from './types';

export const updateOrgCoordinates = async (data: ApiCoordinatesData) => {
  let response;

  try {
    response = await api.post<any, ApiResponseData<ApiUpdateResponseData>>(
      routes.updateOrgCoordinates(),
      data
    );
  } catch (error: any) {
    response = error?.response?.data;
  }

  return response;
};
